"use client"

import { Link2 } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function CopyLinkButton({ label, copiedLabel }: { label: string; copiedLabel: string }) {
  return (
    <>
      <button
        type="button"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(window.location.href);
            toast.success(copiedLabel);
          } catch {
            // Sin permiso de portapapeles no hay nada útil que mostrar.
          }
        }}
        className="inline-flex h-12 cursor-pointer items-center gap-2 rounded-md border border-cyan-600 px-6 font-semibold text-cyan-600 transition-all hover:bg-cyan-600 hover:text-white"
      >
        <Link2 className="h-5 w-5" aria-hidden="true" />
        {label}
      </button>
      <Toaster position="top-center" richColors />
    </>
  );
}
